import request from './adminRequest'

export const dataSourceApi = {
  // 查询数据源列表
  listDataSource (params) {
    return request.get('/datasource/list', { params: params })
  },
  // 查询数据源详情
  getDataSource (id) {
    return request.get('/datasource/' + id)
  },
  // 更新数据源信息
  updateDataSource (id, data) {
    return request.put('/datasource/' + id, data)
  },
  // 数据源状态上报
  reportDataSource (data) {
    return request.post('/datasource/report', data)
  },
}

export default dataSourceApi
